import React from 'react'
import { render } from 'react-dom'
// import './index.css'
import BrowserRouter from 'react-router-dom/BrowserRouter'
import App from './App'
// import registerServiceWorker from './registerServiceWorker'
import {
  ApolloProvider,
  ApolloClient,
  // createNetworkInterface
  createBatchingNetworkInterface
} from 'react-apollo'

// import './index.css'

// const networkInterface = createNetworkInterface({
const networkInterface = createBatchingNetworkInterface({
  // uri: `http://${config.host}:${config.port}/graphql`,
  uri: process.env.REACT_APP_API_URI,
  opts: {
    // credentials: 'same-origin',
    credentials: 'include',
    headers: {
      'X-ThaiRun-Client-ID': process.env.REACT_APP_CLIENT_ID
      // 'X-CRF-Token': safeConfigGet(['apiUrl']),
      // token: safeConfigGet(['apiUrl'])
    }
  }
})

const apolloClient = new ApolloClient({
  // initialState: window.__APOLLO_STATE__,
  networkInterface
})

render(
  <ApolloProvider client={apolloClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById('root')
)

// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js